import React, { createContext, useContext, useState, useEffect } from 'react';

const UserContext = createContext();

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};

export const UserProvider = ({ children }) => {
  const [userPermissions, setUserPermissions] = useState([]);
  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Load user data from localStorage on mount
  useEffect(() => {
    const loadUserData = () => {
      try {
        const storedUserData = localStorage.getItem('userData');
        const storedPermissions = localStorage.getItem('userPermissions');
        
        
        if (storedUserData) {
          const parsedData = JSON.parse(storedUserData);
          setUserData(parsedData);
        }
        
        if (storedPermissions) {
          const parsedPermissions = JSON.parse(storedPermissions);
          setUserPermissions(parsedPermissions);
        }
      } catch (error) {
        // Error handling
      } finally {
        setIsLoading(false);
      }
    };

    loadUserData();
  }, []);

  // Update user data and permissions
  const updateUserData = (data, permissions = []) => {
    
    setUserData(data);
    setUserPermissions(permissions);
    
    // Store in localStorage
    localStorage.setItem('userData', JSON.stringify(data));
    localStorage.setItem('userPermissions', JSON.stringify(permissions));
    
  };

  // Clear user data on logout
  const clearUserData = () => {
    setUserData(null);
    setUserPermissions([]);
    localStorage.removeItem('userData');
    localStorage.removeItem('userPermissions');
    localStorage.removeItem('authToken'); // Clear authentication token
  };

  // Check if user has specific permission
  const hasPermission = (permission) => {
    return userPermissions.includes(permission);
  };

  // Check if user has any of the given permissions
  const hasAnyPermission = (permissions) => {
    return permissions.some(permission => userPermissions.includes(permission));
  };

  // Check if user has all of the given permissions
  const hasAllPermissions = (permissions) => {
    return permissions.every(permission => userPermissions.includes(permission));
  };

  // Check if user is a master affiliate
  const isMasterAffiliate = () => {
    if (!userData) {
      return false;
    }
    
    
    // Check the correct parameter name and value types
    const result = userData.isMasterAffiliate === true || 
                   userData.isMasterAffiliate === 'true';
    
    
    return result;
  };

  const value = {
    userData,
    userPermissions,
    isLoading,
    updateUserData,
    clearUserData,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    isMasterAffiliate
  };

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
};

